module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('router-link', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    },
    attrs: {
      "to": "/addmushroom"
    }
  }, [_c('icon', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "name": "save"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "h6 text-left",
    staticStyle: {
      "height": "30px",
      "margin-top": "0px",
      "margin-bottom": "0px",
      "padding-top": "13px",
      "width": "150px"
    }
  }, [_vm._v("  เพิ่มข้อมูลเห็ด")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('router-link', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    },
    attrs: {
      "to": "/ownmushroom"
    }
  }, [_c('icon', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "name": "th"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "h6 text-left",
    staticStyle: {
      "height": "30px",
      "margin-top": "0px",
      "margin-bottom": "0px",
      "padding-top": "13px",
      "width": "150px"
    }
  }, [_vm._v("  ข้อมูลเห็ดของท่าน")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('router-link', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    },
    attrs: {
      "to": "/allmushroom"
    }
  }, [_c('icon', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "name": "list"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "h6 text-left",
    staticStyle: {
      "height": "30px",
      "margin-top": "0px",
      "margin-bottom": "0px",
      "padding-top": "13px",
      "width": "150px"
    }
  }, [_vm._v("  ข้อมูลเห็ดทั้งหมด")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('router-link', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    },
    attrs: {
      "to": "/sendmushroom"
    }
  }, [_c('icon', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "name": "th"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "h6 text-left",
    staticStyle: {
      "height": "30px",
      "margin-top": "0px",
      "margin-bottom": "0px",
      "padding-top": "13px",
      "width": "150px"
    }
  }, [_vm._v("  ข้อมูลการส่งเห็ด")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('router-link', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    },
    attrs: {
      "to": "/confirmandalert"
    }
  }, [_c('icon', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "name": "save"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "h6 text-left",
    staticStyle: {
      "height": "30px",
      "margin-top": "0px",
      "margin-bottom": "0px",
      "padding-top": "13px",
      "width": "150px"
    }
  }, [_vm._v("  บันทึกผลยืนยันและแจ้งเตือน")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-326fffd5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuDMSC.vue
// module id = 1084
// module chunks = 1